module.exports = __webpack_public_path__ + "img/a-1.6c9aff3c.png";